import { useMemo, useState } from 'react';
import TrainingExpertProgress from '../../training-module/TrainingExpertProgress';
import { useAuth } from '../../context/useAuth';
import { openFoodModule } from '../../utils/foodModule';

/** Seguimiento FOOD: SSO embebido → Nest /trainer (mismo producto que foodplan.tech). */
function FoodCoachTrackingPanel({ onOpen = null, loading: loadingProp = null, error: errorProp = null }) {
  const { user } = useAuth();
  const [internalLoading, setInternalLoading] = useState(false);
  const [internalError, setInternalError] = useState('');

  const loading = loadingProp != null ? loadingProp : internalLoading;
  const error = errorProp != null ? errorProp : internalError;

  const handleOpen = async () => {
    if (typeof onOpen === 'function') {
      await onOpen();
      return;
    }
    setInternalLoading(true);
    setInternalError('');
    try {
      sessionStorage.setItem('d28d_food_coach_tracking', '1');
    } catch { /* noop */ }
    try {
      const result = await openFoodModule('/trainer', { user, coach: true });
      if (!result?.ok && !result?.redirecting) {
        setInternalError(result?.error || 'No se pudo abrir FOOD PLAN');
      }
    } catch (err) {
      setInternalError(err?.message || 'No se pudo abrir FOOD PLAN');
    } finally {
      setInternalLoading(false);
    }
  };

  return (
    <div className="surface-readable training-light-island d28d-admin-surface ui-light-panel ui-light-surface border border-slate-200 rounded-xl bg-white max-w-2xl p-6 space-y-4">
      <h3 className="text-xl font-bold text-stone-900 m-0">Seguimiento FOOD_PLAN</h3>
      <p className="text-sm text-stone-600 leading-relaxed m-0">
        Abre el panel de entrenador FOOD dentro del ecosistema (/food) — misma app Nest, con SSO.
      </p>
      {error ? <p className="text-sm text-red-600 m-0">{error}</p> : null}
      <button
        type="button"
        className="food-external-cta"
        disabled={loading}
        onClick={handleOpen}
      >
        {loading ? 'Conectando…' : 'Abrir Seguimiento FOOD'}
      </button>
    </div>
  );
}

export { FoodCoachTrackingPanel };

export default function CoachEcosystemTracking({ onBack = null }) {
  const { user } = useAuth();
  const [tab, setTab] = useState('training');
  const [foodLoading, setFoodLoading] = useState(false);
  const [foodError, setFoodError] = useState('');

  const openFoodTrainer = async () => {
    setFoodLoading(true);
    setFoodError('');
    try {
      sessionStorage.setItem('d28d_food_coach_tracking', '1');
    } catch { /* noop */ }
    const result = await openFoodModule('/trainer', { user, coach: true });
    if (!result?.ok && !result?.redirecting) {
      setFoodError(result?.error || 'No se pudo abrir FOOD PLAN');
    }
    setFoodLoading(false);
  };

  const tabs = useMemo(() => ([
    { id: 'training', label: 'Seguimiento Training' },
    { id: 'food', label: 'Seguimiento FOOD_PLAN' },
  ]), []);

  return (
    <div className="dashboard-main-view training-coach-view">
      <header className="dashboard-header page-header live-classes-panel__header">
        <div className="flex flex-wrap justify-between gap-3 w-full">
          <div>
            {onBack && (
              <button type="button" className="btn-secondary mb-2" onClick={onBack}>
                ← Volver
              </button>
            )}
            <h1 className="d28d-page-title">Seguimiento</h1>
            <p className="d28d-text-muted subtitle">Dashboard profesional de coach (Training + FOOD embebido).</p>
          </div>
          <div className="flex flex-wrap gap-2 items-end">
            {tabs.map((t) => (
              <button
                key={t.id}
                type="button"
                className={tab === t.id ? 'btn-primary' : 'btn-secondary'}
                onClick={() => setTab(t.id)}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>
      </header>
      <div className="p-4">
        {tab === 'training' ? (
          <TrainingExpertProgress />
        ) : (
          <FoodCoachTrackingPanel
            onOpen={openFoodTrainer}
            loading={foodLoading}
            error={foodError}
          />
        )}
      </div>
    </div>
  );
}
